const BASE_URL: string = "https://www.dfos.kr:30004";
// const BASE_URL: string = "http://192.168.0.75:30004";
export const GRAPHQL = `${BASE_URL}/graphql`;
export const IMAGE_SERVER: string = "https://file.dfos.kr";
// export const IMAGE_SERVER: string = "D:\\dfos-platform";

export const USER: string = `${BASE_URL}/user`;
export const SPECIFIC_USER = (seq: number): string => `${USER}/${seq}`;
export const DELETE_USERS = `${USER}/delete`;
export const EXPORT_USERS_TO_EXCEL = `${USER}/excel`;
export const UPDATE_USER_THUMBNAIL = `${USER}/thumbnail`;

export const INSTITUTION: string = `${BASE_URL}/institution`;
export const DELETE_INSTITUTION = (seq: number) => `${INSTITUTION}/${seq}`;
export const EXPORT_INSTITUTIONS_TO_EXCEL = `${INSTITUTION}/excel`;
export const SET_LICENSE_ACTIVATION = (seq: number) => `${INSTITUTION}/${seq}/license`;

export const NOTICE = `${BASE_URL}/notice`;
export const DELETE_NOTICE = `${NOTICE}/delete`;
export const EXPORT_NOTICES_TO_EXCEL = `${NOTICE}/excel`;

export const FAQ: string = `${BASE_URL}/faq`;
export const FAQ_DELETE: string = `${FAQ}/delete`;

export const INQUIRY: string = `${BASE_URL}/inquiry`;
export const COMPLETE_INQUIRY = (seq: number): string => `${INQUIRY}/${seq}`;
export const EXPORT_INQUIRIES_TO_EXCEL = `${INQUIRY}/excel`;

export const LOGIN: string = `${BASE_URL}/login`;
export const PUBLIC_KEY: string = `${LOGIN}/key`;

export const LECTURE: string = `${BASE_URL}/lecture`;
export const LECTURE_ADD: string = `${LECTURE}/add`;
export const LECTURE_UPLOAD: string = `${LECTURE}/add/upload`;
export const LECTURE_ACTIVATE_UPDATE = (lectureSeq: number): string => `${LECTURE}/activate/${lectureSeq}`;
export const LECTURE_DELETE: string = `${LECTURE}/delete`;
export const EXPORT_LECTURES_TO_EXCEL = `${LECTURE}/excel`;
export const LECTURE_PAYMENT = (lectureSeq: number): string => `${LECTURE}/${lectureSeq}/payment`;

export const LICENSE: string = `${BASE_URL}/license`;
export const EXPORT_LICENSES_TO_EXCEL = `${LICENSE}/excel`;
export const UNSUBSCRIBE_LICENSE = `${LICENSE}/unsubscribe`;
export const UPDATE_LICENSE = (userSeq: number) => `${LICENSE}/${userSeq}`;

export const PAYMENT: string = `${BASE_URL}/payment`;
export const EXPORT_PAYMENTS_TO_EXCEL: string = `${PAYMENT}/excel`;
export const PAYMENT_CANCEL = (seq: number): string => `${PAYMENT}/cancel/${seq}`;
export const PAYMENT_REFUND = (seq: number): string => `${PAYMENT}/refund/${seq}`;